var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-container"
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      placeholder: "Created By"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.createdBy,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "createdBy", $$v);
      },
      expression: "listQuery.createdBy"
    }
  }, _vm._l(_vm.accountManagerOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-select", {
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.branchListLoading,
      "loading-text": "fetching branches...",
      "remote-method": _vm.fetchBranches,
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.branchId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "branchId", $$v);
      },
      expression: "listQuery.branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(" | ID: " + _vm._s(dealer.id))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: _vm.isPaymentManager,
      clearable: "",
      placeholder: "Payment Type"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.paymentType,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "paymentType", $$v);
      },
      expression: "listQuery.paymentType"
    }
  }, _vm._l(_vm.paymentMethods, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "mini",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.exportToExcel
    }
  }, [_vm._v(" Export to Excel ")]), !_vm.isAccountManager && !_vm.isReadOnly ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "success",
      size: "mini",
      icon: "el-icon-check",
      disabled: _vm.selectedLedgerIds.length === 0
    },
    on: {
      click: _vm.approveSelectedLedgers
    }
  }, [_vm._v(" Approve Selected ")]) : _vm._e(), !_vm.isAccountManager && !_vm.isReadOnly ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "danger",
      size: "mini",
      icon: "el-icon-close",
      disabled: _vm.selectedLedgerIds.length === 0
    },
    on: {
      click: _vm.rejectSelectedLedgers
    }
  }, [_vm._v(" Reject Selected ")]) : _vm._e()], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "80",
      label: "Date",
      prop: "createdTimestamp"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(scope.row.createdTimestamp)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Created By",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(_vm.accountManagers[scope.row.createdBy]))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Voucher No.",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.ledgerInvoiceNumber))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "180",
      label: "Payment Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$transactio, _scope$row, _scope$row2, _scope$row$transactio2;
        return [scope.row.transactionId ? _c("span", [_vm._v(" " + _vm._s(((_scope$row$transactio = scope.row.transaction) === null || _scope$row$transactio === void 0 ? void 0 : _scope$row$transactio.paymentMode) || scope.row.paymentType) + " "), _c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: "Description: " + (((_scope$row = scope.row) === null || _scope$row === void 0 || (_scope$row = _scope$row.transaction) === null || _scope$row === void 0 ? void 0 : _scope$row.comments) || ((_scope$row2 = scope.row) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.comments)) + " \n" + "Transaction Reference: " + (((_scope$row$transactio2 = scope.row.transaction) === null || _scope$row$transactio2 === void 0 ? void 0 : _scope$row$transactio2.referenceNumber) || ""),
            placement: "top-start"
          }
        })], 1) : _c("span", [scope.row.ordersDispatch ? _c("el-link", {
          attrs: {
            type: "primary",
            target: "_blank",
            disabled: scope.row.fromTally
          },
          on: {
            click: function ($event) {
              return _vm.downloadInvoice(scope.row.ordersDispatchId);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.ordersDispatch.invoiceNumber) + " "), scope.row.paymentType === "Credit Note-Item Wise" || scope.row.paymentType === "Debit Note-Item Wise" || scope.row.paymentType === "Replacement" ? _c("span", [_vm._v(" - " + _vm._s(scope.row.paymentType) + " ")]) : _vm._e()]) : scope.row.paymentType === "Credit Note" ? _c("span", [_vm._v(" " + _vm._s(scope.row.paymentType) + " "), _c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: `Description: ${scope.row.comments}`
          }
        }, [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(`Reference: ${scope.row.transactionReference}`) + " ")])], 1)], 1) : _c("span", [_vm._v(" " + _vm._s(scope.row.paymentType) + " "), _c("el-tooltip", {
          attrs: {
            effect: "dark",
            content: `Description: ${scope.row.type}`
          }
        }, [_c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v(" " + _vm._s(`Reference: ${scope.row.transactionReference}`) + " ")])], 1)], 1)], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "300",
      label: "Dealer",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.dealer.name))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      label: "Narration",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", {
          staticStyle: {
            cursor: "pointer",
            color: "black"
          },
          on: {
            click: function ($event) {
              return _vm.editNarration(scope.row);
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.comments) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Amount",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: Math.round(scope.row.amount)
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "80",
      label: "Date",
      prop: "actualCreatedTimestamp",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(scope.row.actualCreatedTimestamp)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      type: "selection",
      width: "35",
      align: "center"
    }
  }), !_vm.isAgent ? _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "230",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!_vm.isReadOnly ? _c("router-link", {
          attrs: {
            to: "/ledgers/edit/" + scope.row.id
          }
        }, [(scope.row.paymentType === "Credit Note-Item Wise" || scope.row.paymentType === "Debit Note-Item Wise" || scope.row.paymentType === "Purchase" || scope.row.paymentType === "Credit Note Inward") && !scope.row.fromTally ? _c("el-button", {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            type: "primary",
            size: "mini",
            icon: "el-icon-edit"
          }
        }) : _vm._e()], 1) : _vm._e(), scope.row.paymentType === "Credit Note" || scope.row.paymentType === "Credit Note-Item Wise" || scope.row.paymentType === "Credit Note Inward" || scope.row.paymentType === "Purchase" ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-document"
          },
          on: {
            click: function ($event) {
              return _vm.viewPdf(scope.row, false);
            }
          }
        }) : _vm._e(), (scope.row.paymentType === "Credit Note" || scope.row.paymentType === "Credit Note-Item Wise" || scope.row.paymentType === "Credit Note Inward" || scope.row.paymentType === "Purchase") && scope.row.ledgerAttachmentS3Url ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-view"
          },
          on: {
            click: function ($event) {
              return _vm.viewPdf(scope.row, true);
            }
          }
        }) : _vm._e(), _vm.isSuperAdmin && scope.row.approvalStatus !== "Approved" && scope.row.action === "credit" && !_vm.isPaymentManager ? _c("el-button", {
          attrs: {
            type: "danger",
            size: "mini",
            icon: "el-icon-close"
          },
          on: {
            click: function ($event) {
              return _vm.handleLedgerAction([scope.row.id], "reject", "credit");
            }
          }
        }) : _vm._e(), _vm.isSuperAdmin && scope.row.approvalStatus !== "Approved" && scope.row.action === "credit" && !_vm.isPaymentManager ? _c("el-button", {
          attrs: {
            type: "success",
            size: "mini",
            icon: "el-icon-check"
          },
          on: {
            click: function ($event) {
              return _vm.handleLedgerAction([scope.row.id], "approve", "credit");
            }
          }
        }) : _vm._e(), _vm.isPaymentManager && scope.row.approvalStatus === "Pending" && scope.row.paymentType === "Payment" ? _c("el-button", {
          attrs: {
            type: "success",
            size: "mini",
            icon: "el-icon-check"
          },
          on: {
            click: function ($event) {
              return _vm.handleLedgerAction([scope.row.id], "approve", "payment");
            }
          }
        }) : _vm._e(), _vm.isPaymentManager && scope.row.approvalStatus === "Pending" && scope.row.paymentType === "Payment" ? _c("el-button", {
          attrs: {
            type: "danger",
            size: "mini",
            icon: "el-icon-close"
          },
          on: {
            click: function ($event) {
              return _vm.handleLedgerAction([scope.row.id], "reject", "payment");
            }
          }
        }) : _vm._e()];
      }
    }], null, false, 743249663)
  }) : _vm._e()], 1), _c("el-dialog", {
    attrs: {
      title: "Edit Narration",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "New Narration",
      "label-width": "120px"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea"
    },
    model: {
      value: _vm.form.comments,
      callback: function ($$v) {
        _vm.$set(_vm.form, "comments", $$v);
      },
      expression: "form.comments"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogFormVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveNarration
    }
  }, [_vm._v("Confirm")])], 1)], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit,
      "page-sizes": [50, 100, 200, 500, 1000]
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };